export default __webpack_public_path__ + "static/media/empty-icon.0e5fd287.svg";